// Rep Mode V2 helpers. Pure functions only (tested in src/tests/repUtils.test.js).

import { EMPTY_VALUE } from "../../ForCoaches/v2/coachUtils";

// Badge tone for a deal-activity label from rep/home rows.
export const activityTone = (row) => {
  if (!row) return "passive";
  if (row.activityTone === "critical") return "critical";
  if (row.activity === "No activity") return "passive";
  return "outline";
};

// Profile column: minors without a guardian outrank completion.
export const profileLabel = (row) => {
  if (!row) return { text: EMPTY_VALUE, tone: "muted" };
  if (row.guardianMissing) return { text: "Guardian missing", tone: "attention" };
  const pct = Math.round(Number(row.profileCompletion) || 0);
  return { text: `${pct}% complete`, tone: pct >= 100 ? "ink" : "muted" };
};

// Athletes table filter chips.
export const filterRows = (rows, filter) => {
  const list = rows || [];
  if (filter === "deals") return list.filter((r) => (r.deals || []).length > 0);
  if (filter === "flags") return list.filter((r) => r.activityTone === "critical" || r.guardianMissing);
  if (filter === "quiet") return list.filter((r) => !(r.deals || []).length);
  return list;
};

export const rowCounts = (rows) => ({
  all: (rows || []).length,
  deals: filterRows(rows, "deals").length,
  flags: filterRows(rows, "flags").length,
  quiet: filterRows(rows, "quiet").length,
});

// Rep IDs are typed by athletes: accept lowercase and a missing dash.
export const normalizeRepCode = (raw) => {
  const s = String(raw || "").trim().toUpperCase().replace(/\s+/g, "");
  if (!s) return "";
  if (/^REP-?[A-Z0-9]{6}$/.test(s)) return `REP-${s.slice(-6)}`;
  return s;
};

export const isRepCode = (raw) => /^REP-[A-Z0-9]{6}$/.test(normalizeRepCode(raw));

// Subtitle under an athlete's name: "OH · Volleyball".
export const athleteSubtitle = (row) => [row?.position, row?.sport].filter(Boolean).join(" · ");
